import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import useIsMountedRef from 'common/hooks/useIsMountedRef';
import {sftpUsersActions} from '..';
import {ISftpUser} from 'types/diplomat/sftp/SftpUser';

const actionsMap = {
   ssh: sftpUsersActions.getRefsSsh,
};

export const useSftpsRefs = (id: string, type: 'ssh') => {
   const isMountedRef = useIsMountedRef();
   const dispatch = useDispatch();
   const [sftps, setSftps] = useState<ISftpUser[]>([]);
   useEffect(() => {
      const action = actionsMap[type];
      dispatch(
         action(id, {
            onSuccess: (_synchronizations: ISftpUser[]) => {
               if (isMountedRef.current) {
                  setSftps(_synchronizations);
               }
            },
         })
      );
   }, [dispatch, id, isMountedRef, type]);

   return sftps;
};
